module.exports = __webpack_public_path__ + "static/background-f807bbf9f5c661e18ef6c1201c643ca1.png";